var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Videos',{attrs:{"videoContents":_vm.videoContents,"imageContents":_vm.imageContents,"activeTab":_vm.activeTab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }